import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { DataService } from '../../services/data/data.service';
import { DisplayService } from '../../services/display/display.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { NoteService } from '../../services/note/note.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { ModalFormComponent } from '../modal-form/modal-form.component';

@Component({
	selector: 'pcm-modal-form-migrate-timesheets',
	templateUrl: './modal-form-migrate-timesheets.component.html',
	styleUrls: [
		'../modal-form/modal-form.component.scss',
		'./modal-form-migrate-timesheets.component.scss'
	]
})
export class ModalFormMigrateTimesheetsComponent extends ModalFormComponent implements OnInit {

	poNumber = '';
	contractorId = '';
	supplierid = '';
	columsConfig = [];

	constructor(
		public configService: ConfigService,
		public dataService: DataService,
		public displayService: DisplayService,
		public smartContractService: SmartContractService,
		public noteService: NoteService,
		public contractorService: ContractorService
	) {
		super(configService, dataService, displayService, smartContractService);
	}
	ngOnInit() {
		this.tableHelp = 'Select a PO from the list below to migrate timesheet. If you do not see your PO below, please ensure your contractor has been fully set-up and approved on that PO.';
		// dont show lineitemnum and supplierconid to save space
		const tableFields = this.configService.getTableFields(this.tableService['dataObj'], true);
		this.columsConfig = [];
		tableFields.forEach(field => {
			if (field.prop !== this.configService.lineItemIndexProp
				&& field.prop !== this.configService.supplierContractorId) {
				this.columsConfig.push(field);
			}
		});
		this.modalTable = true;
		super.ngOnInit();
	}

	showModal(basicData, scDataObj, relatedData) {
		// need clean the table everytime when open the modal
		this.dataService.data[this.contractorService.migrateTSDataObj] = [];
		this.tableTab['page'] = 0;
		this.updatePageDataForTab(this.tableTab);
		// check if the timesheets have the same contractor email
		let filteredData = [];
		let contractorEmail = '';
		let contractorPonum = '';
		try {
			contractorEmail = relatedData[0]['acl']['contractor']['participants'][0];
			contractorPonum = relatedData[0][this.configService.poNumberProp];
			filteredData = relatedData.filter( timesheet => {
				const sameEmail = timesheet['acl']['contractor']['participants'][0] === contractorEmail;
				const samePO = timesheet[this.configService.poNumberProp] === contractorPonum;
				return sameEmail && samePO;
			});
		} catch (error) {
			console.error('Timesheets doesnt have contractor email');
		}
		if (filteredData.length === relatedData.length) {
			this.contractorService.loadContractorsForMigrateTS(this.contractorService.getActiveTab(this.contractorService.tabsData.migrateTSListTabs), contractorEmail, contractorPonum);
			super.showModal(basicData, scDataObj, relatedData);
		} else {
			this.noteService.displayError('The selected timesheets cannot be migrated together as they belong to different contractors/POs. Please select timesheets for one contractor and one purchase order at a time.');
		}
	}

	tableClick(event) {
		console.log('MIGRATE TIMESHEET MODAL TABLE CLICK: ', event);
		const clickedRow = event.row;
		this.poNumber = clickedRow[this.configService.poNumberProp];
		this.supplierid = clickedRow[this.configService.supplierIdProp];
		this.contractorId = clickedRow[this.configService.contractorIdProp];
	}

	tablePage(event) {
		console.log('MIGRATE TIMESHEET MODAL TABLE PAGE: ', event);
		this.tableTab['page'] = event.offset;
		this.updatePageDataForTab(this.tableTab);
	}

	updatePageDataForTab(tab) {
		const contractors = this.dataService.data[this.contractorService.migrateTSDataObj];
		const dataRef = this.contractorService.migrateTSDataObj + '-' + tab.prop + '-' + tab.type;
		const pSize = this.contractorService.migratePageSize;
		const bIdx = tab.page * pSize;
		const eIdx = (tab.page + 1) * pSize >= contractors.length ? contractors.length : (tab.page + 1) * pSize;
		this.dataService.updatePageData(dataRef, tab, contractors.slice(bIdx, eIdx));
		this.dataService.updateDataCount(dataRef, contractors.length);
	}

	formSubmit(event) {
		console.log('MIGRATE TIMESHEET FORM SUBMIT', event);
		if (!this.poNumber || !this.contractorId) {
			this.noteService.displayError('Failed to migrate the selected timesheets since no PO is available for migration.');
		} else {
			const submitData = event.data;
			submitData[this.configService.poNumberProp] = this.poNumber;
			submitData[this.configService.contractorIdProp] = this.contractorId;
			submitData[this.configService.supplierIdProp] = this.supplierid;
			console.log('MIGRATE TIMESHEET SUBMIT DATA', submitData);
			const modalEvent = {
				event: event.event,
				prop: this.modalProp,
				data: submitData
			};
			this.modalSubmit.emit(modalEvent);
		}
	}

}
